import React, { useState } from "react";

import { message } from "antd";
import Joi from "joi-browser";
import Form from "V2.0/components/Form";
import * as authService from "V2.0/services/portalAuthService";
import { showErrorToast } from "V2.0/utils";
import Logo from "./common/Logo";

function ForgotPassword(props) {
  const [inputField] = useState({
    email: "",
  });
  const [loading, setLoading] = useState(false);
  const [errorMessage] = useState({});

  const template = [
    {
      name: "email",
      label: "Email *",
      type: "email",
      placeholder: "youremail@example.com",
    },
  ];

  const buttonInfo = {
    label: "Email Password Reset Link",
    style: "entire-width",
  };

  const schema = {
    email: Joi.string().email().required().label("Email"),
  };

  const handleSubmit = async (email) => {
    try {
      const response = await authService.sendOptOnEmail(email);
      if (response.status === 200) {
        setLoading(false);
        message.success("Password reset link email sent");
      }
    } catch (e) {
      setLoading(false);
      showErrorToast(e, "Failed to send email");
    }
  };

  return (
    <div className="bg-slate-50 flex items-center justify-center h-screen w-screen">
      <div className="relative w-[500px] rounded-xl bg-white shadow-[0px_0px_0px_1px_rgba(9,9,11,0.07),0px_2px_2px_0px_rgba(9,9,11,0.05)] dark:bg-zinc-900 dark:shadow-[0px_0px_0px_1px_rgba(255,255,255,0.1)] p-20">
        <div className="space-y-8">
          <Logo />
          <Form
            formTitle={"Forgot Password"}
            errorMessage={errorMessage}
            inputField={inputField}
            template={template}
            schema={schema}
            buttonInfo={buttonInfo}
            onSubmit={handleSubmit}
            loading={loading}
            setLoading={setLoading}
          />
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
